/* eslint react/forbid-prop-types: 0 */
/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { SubscriptionBlocks, PaymentMethodsLogos, SubscriptionCoupon } from '../../components/payments';

const SubscriptionTermsContainer = (props) => {
  const {
    type,
    terms,
    active,
  } = props;

  const hasActiveCoupons = get(globals, 'hasActiveCoupons', false);

  return (
    <div className="paymentPeriod-container-wrapper">
      <SubscriptionBlocks
        termsData={terms}
        chosenOption={active}
      />
      <div className={`paymentFooter${type === 'subscription_other' ? ' paymentFooter--gift' : ''}`}>
        <PaymentMethodsLogos
          termsData={terms}
          active={active}
        />
        <div className="paymentCouponCodeInput ptm prm plm tar">
          {hasActiveCoupons ? (
            <SubscriptionCoupon
              active={active}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

SubscriptionTermsContainer.propTypes = {
  type: PropTypes.string.isRequired,
  terms: PropTypes.instanceOf(Object).isRequired,
  active: PropTypes.string,
};
SubscriptionTermsContainer.defaultProps = {
  active: null,
};

export default SubscriptionTermsContainer;
